export const translations = {
  en: {
    // Header & Search
    appName: 'ClimaSense',
    appSubtitle: 'LIVE WEATHER INTELLIGENCE',
    searchPlaceholder: 'Search for a city...',
    search: 'Search',
    currentLocation: 'Current Location',
    popular: 'POPULAR:',
    weatherStation: 'WEATHER STATION',
    home: 'Home',
    homeSubtitle: 'Minimal live weather dashboard for local decisions.',

    // Nav
    nav: { home: 'Home', map: 'Map', forecast: 'Forecast', hourly: 'Hourly', ai: 'AI' },

    // Weather card
    updatedJustNow: 'Updated just now',
    feelsLike: 'Feels like',
    day: 'Day',
    night: 'Night',

    // Stats
    wind: 'Wind',
    humidity: 'Humidity',
    pressure: 'Pressure',
    visibility: 'Visibility',

    // Highlights
    cloudCover: 'Cloud Cover',
    condition: 'Condition',
    uvIndex: 'UV Index',
    poor: 'Poor',
    clear: 'Clear',
    low: 'Low',
    high: 'High',

    // Sections
    atmosphericOverview: 'Atmospheric Overview',
    liveConditions: 'LIVE CONDITIONS',
    weatherHighlights: 'WEATHER HIGHLIGHTS',
    weatherMap: 'Weather Map',
    hourlyForecast: 'Hourly Forecast',
    fiveDayForecast: '5-Day Forecast',
    dailyPlanner: 'Daily Planner',
    airQuality: 'Air Quality',
    sunriseSunset: 'Sunrise & Sunset',
    uvIndexLabel: 'UV Index',
    precipitation: 'Precipitation',
    visibilityLabel: 'Visibility',

    // Map layers
    temperature: 'Temperature',
    clouds: 'Clouds',

    // Daily Planner
    todayTimeline: "Today's Timeline",
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening',
    seasonalPlanning: 'Seasonal Planning',
    bestActivityWindow: 'Best Activity Window',
    regionalInsights: 'Regional Insights',

    // Sunrise
    sunrise: 'Sunrise',
    sunset: 'Sunset',
    currentTime: 'Current Time',
    daylight: 'daylight',

    // AQI
    aqiIndex: 'AQI Index',
    good: 'Good',
    moderate: 'Moderate',
    unhealthy: 'Unhealthy',
    hazardous: 'Hazardous',

    // Forecast
    chance: 'chance',

    // Footer
    poweredBy: 'Powered by',
    toggleTheme: 'Toggle Theme',

    // Weather descriptions
    weatherDesc: {
      'clear sky': 'Clear Sky',
      'mainly clear': 'Mainly Clear',
      'partly cloudy': 'Partly Cloudy',
      'overcast clouds': 'Overcast Clouds',
      'foggy': 'Foggy',
      'light drizzle': 'Light Drizzle',
      'moderate drizzle': 'Moderate Drizzle',
      'heavy drizzle': 'Heavy Drizzle',
      'light rain': 'Light Rain',
      'moderate rain': 'Moderate Rain',
      'heavy rain': 'Heavy Rain',
      'thunderstorm': 'Thunderstorm',
      'light showers': 'Light Showers',
      'moderate showers': 'Moderate Showers',
      'heavy showers': 'Heavy Showers',
    }
  },

  km: {
    // Header & Search
    appName: 'ClimaS​ense',
    appSubtitle: 'ព័ត៌មានអាកាសធាតុផ្ទាល់',
    searchPlaceholder: 'ស្វែងរកទីក្រុង...',
    search: 'ស្វែងរក',
    currentLocation: 'ទីតាំងបច្ចុប្បន្ន',
    popular: 'ពេញនិយម:',
    weatherStation: 'ស្ថានីយ​អាកាសធាតុ',
    home: 'ទំព័រដើម',
    homeSubtitle: 'ផ្ទាំងព័ត៌មានអាកាសធាតុផ្ទាល់ សម្រាប់ការសម្រេចចិត្តក្នុងស្រុក។',

    // Nav
    nav: { home: 'ដើម', map: 'ផែនទី', forecast: 'ព្យាករណ៍', hourly: 'ម៉ោង', ai: 'AI' },

    // Weather card
    updatedJustNow: 'បានធ្វើបច្ចុប្បន្នភាព',
    feelsLike: 'មានអារម្មណ៍ដូច',
    day: 'ថ្ងៃ',
    night: 'យប់',

    // Stats
    wind: 'ខ្យល់',
    humidity: 'សំណើម',
    pressure: 'សម្ពាធ',
    visibility: 'ភាពច្បាស់',

    // Highlights
    cloudCover: 'ពពកគ្រប',
    condition: 'ស្ថានភាព',
    uvIndex: 'សន្ទស្សន៍ UV',
    poor: 'ខ្សោយ',
    clear: 'ច្បាស់',
    low: 'ទាប',
    high: 'ខ្ពស់',

    // Sections
    atmosphericOverview: 'ទិដ្ឋភាពបរិយាកាស',
    liveConditions: 'ស្ថានភាពផ្ទាល់',
    weatherHighlights: 'សង្ខេបអាកាសធាតុ',
    weatherMap: 'ផែនទីអាកាសធាតុ',
    hourlyForecast: 'ព្យាករណ៍ម៉ោង',
    fiveDayForecast: 'ព្យាករណ៍ ៥ ថ្ងៃ',
    dailyPlanner: 'ផែនការប្រចាំថ្ងៃ',
    airQuality: 'គុណភាពខ្យល់',
    sunriseSunset: 'ថ្ងៃរះ និង ថ្ងៃលិច',
    uvIndexLabel: 'សន្ទស្សន៍ UV',
    precipitation: 'ភ្លៀង',
    visibilityLabel: 'ភាពច្បាស់',

    // Map layers
    temperature: 'សីតុណ្ហភាព',
    clouds: 'ពពក',

    // Daily Planner
    todayTimeline: 'កាលវិភាគថ្ងៃនេះ',
    morning: 'ព្រឹក',
    afternoon: 'ថ្ងៃ',
    evening: 'ល្ងាច',
    seasonalPlanning: 'ផែនការតាមរដូវ',
    bestActivityWindow: 'ពេលល្អបំផុតសម្រាប់សកម្មភាព',
    regionalInsights: 'ព័ត៌មានតំបន់',

    // Sunrise
    sunrise: 'ថ្ងៃរះ',
    sunset: 'ថ្ងៃលិច',
    currentTime: 'ម៉ោងបច្ចុប្បន្ន',
    daylight: 'ពន្លឺថ្ងៃ',

    // AQI
    aqiIndex: 'សន្ទស្សន៍ AQI',
    good: 'ល្អ',
    moderate: 'មធ្យម',
    unhealthy: 'មិនល្អ',
    hazardous: 'គ្រោះថ្នាក់',

    // Forecast
    chance: 'ឱកាស',

    // Footer
    poweredBy: 'ដំណើរការដោយ',
    toggleTheme: 'ប្តូររូបរាង',

    // Weather descriptions
    weatherDesc: {
      'clear sky': 'អាកាស맑',
      'mainly clear': 'ភាគច្រើន맑',
      'partly cloudy': 'ពពកខ្លះ',
      'overcast clouds': 'ពពកច្រើន',
      'foggy': 'មានអ័ព្ទ',
      'light drizzle': 'ភ្លៀងស្រាល',
      'moderate drizzle': 'ភ្លៀងមធ្យម',
      'heavy drizzle': 'ភ្លៀងខ្លាំង',
      'light rain': 'ភ្លៀងស្រាល',
      'moderate rain': 'ភ្លៀងមធ្យម',
      'heavy rain': 'ភ្លៀងខ្លាំង',
      'thunderstorm': 'ព្យុះភ្លៀង',
      'light showers': 'ភ្លៀងស្រាល',
      'moderate showers': 'ភ្លៀងមធ្យម',
      'heavy showers': 'ភ្លៀងធ្ងន់',
    }
  }
};

export function t(lang, key) {
  const keys = key.split('.');
  let val = translations[lang] || translations['en'];
  for (const k of keys) {
    val = val?.[k];
  }
  return val ?? key;
}

export function translateWeatherDesc(lang, description) {
  if (!description) return '';
  const lower = description.toLowerCase();
  return translations[lang]?.weatherDesc?.[lower] || description;
}
